import React from "react";

/** Circle diameter (min(94vw, 94vh)) in a maximised browser on a 13"
 *  laptop (~1470x830): the size the content is designed and judged at.
 *  Above it, content scales strictly with the circle, so a large monitor
 *  looks like the laptop, only bigger - same proportions, same chip rows. */
const REFERENCE_CIRCLE_PX = 780;
/** Guards against absurd sizes; a 4K screen at 100% needs about 2.6. */
const MAX_CONTENT_SCALE = 3;

/**
 * The circle grows with the viewport, but its content is sized in fixed
 * pixels, so on large screens it shrinks to a small cluster in an empty
 * circle. This returns how much to scale the content so it keeps its
 * proportion to the circle - never below 1, so smaller laptops and phones
 * keep their own breakpoint styling.
 */
const measure = () =>
  Math.min(
    MAX_CONTENT_SCALE,
    Math.max(
      1,
      (Math.min(window.innerWidth, window.innerHeight) * 0.94) /
        REFERENCE_CIRCLE_PX,
    ),
  );

const useCircleContentScale = () => {
  const [scale, setScale] = React.useState(measure);

  React.useEffect(() => {
    const onResize = () => setScale(measure());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return scale;
};

export default useCircleContentScale;
